/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFAQ = {
  init() {
    const $faqHeading = $('.faq-accordion > dt > button');

    // SV- modified to keep first faq item open by default
    $('.faq-accordion > dd:not(:first-of-type)').attr('aria-hidden', true);
    $('.faq-accordion > dt:not(:first-of-type) > button').attr('aria-expanded', false);
    $('.faq-accordion > dt:first-of-type [data-icon="plus--faq"]').removeClass('icon--active');
    $('.faq-accordion > dt:first-of-type [data-icon="minus--faq"]').addClass('icon--active');

    $faqHeading.off('click activate').on('click activate', function () {
      const faqIcons = $(this).find('.icon');

      const state = $(this).attr('aria-expanded') === 'false';
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(state);
      if (faqIcons.hasClass('icon--active')) {
        faqIcons.toggleClass('icon--active');
      }

      // $(this).parent().next().slideToggle(() => {
      //   if (faqIcons.hasClass('icon--active')) {
      //     faqIcons.toggleClass('icon--active');
      //   }
      // });
      // $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });

    $faqHeading.on('keydown', function (event) {
      const keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });

    // SV-
    document.dispatchEvent(new CustomEvent('faqs-initialized'))
  },
  unload() {
    $('.faq-accordion > dt > button').off('click activate');
    $('.faq-accordion > dt > button').off('keydown');
  },
};

/******/ })()
;